import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ChartComponent } from 'ng-apexcharts';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { debtorsResponse } from '../../../interface/data.interface';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CompaniesFactoringService } from 'src/app/pages/dashboards/factoring/services/companies-factoring.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-table-debtor-favorite',
  templateUrl: './table-debtor-favorite.component.html',
  styleUrls: ['./table-debtor-favorite.component.scss']
})
export class TableDebtorFavoriteComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public dataSource!: MatTableDataSource<any>;
  @Output() changePagination = new EventEmitter<any>();
  @Output() changeSorting = new EventEmitter<string>;
  @Output() actualizarData = new EventEmitter<string>;
  @Input() recieveFilterName: PageResult<debtorsResponse>;
  @Input() booleanFlag: boolean;
  @Input() booleanText: boolean;

  displayedColumns: string[] = [
    'name',
    'rut'
  ];

  constructor(private router: Router, private dialog: MatDialog, private serviceDebtorList: CompaniesFactoringService,) { }

  ngOnInit() {
    this.setDataSource(this.recieveFilterName);
    this.paginator._intl.itemsPerPageLabel = 'items por pagina';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDataSource(this.recieveFilterName);
    if (changes['recieveFilterName']) {
      const newDeptorsFilter = changes['recieveFilterName'].currentValue;
      this.setDataSource(newDeptorsFilter);
    }
  }

  private setDataSource(dataSource: PageResult<debtorsResponse>) {
    const {sortColumn, sortDirection} = dataSource;
    this.dataSource = new MatTableDataSource<debtorsResponse>(dataSource?.results);
    this.paginator.length = dataSource?.totalRows;
    if(sortColumn && sortDirection){
      this.sort.active = sortColumn;
      this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  public changePaginationTable(event: PageEvent) {
    this.changePagination.emit({
      page: event.pageIndex + 1,
      size: event.pageSize,
    });
  }

  public changeSortingTable(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSorting.emit('');
      return;
    }
    const sortOrder = `${sortState.active}_${sortState.direction}`;
    this.changeSorting.emit(sortOrder);
  }

  public dealDialogOpen(args: any): void {
    this.router.navigate(['dashboards/files-clients'], {
      queryParams: { client: +args },
    });
  }

  openDialogConfirm(rut: string) {
    const id = rut.replaceAll('.', '').split('-')[0];
    const companyId = Number.parseInt(id);
    Swal.fire({
      titleText: '¿Deseas Quitar al Cliente de la Lista?',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Quitar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.serviceDebtorList.updateDebtorFavorite(companyId).subscribe({
          next: (res) => {
            Swal.fire({
              title: `Quitado Exitosamnete`,
              icon: 'success',
            });
            this.actualizarData.emit("update");
          },
          error: (err) => {
            console.log(err);
            Swal.fire({
              title: `Error al Quitar de la Lista`,
              icon: 'error',
              text: err.error.resultMessage
            });
          }
        })
      }
    });
  }

}
